module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_ja-94fc389261527cfbdf9ca39e4fadff3d.jpg";